var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDemoClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "For-Brock---MVP-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video-",
    transform: "translate(-1127, -175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(282, 175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(845.3627, 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#ECF8FE",
    cx: 14.7512953,
    cy: 14.7473118,
    rx: 14.7512953,
    ry: 14.7473118
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.8508, 8.8484)",
    stroke: "#61849D",
    strokeLinecap: "round",
    strokeWidth: 1.50237342
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.172762918,
    y1: 0.172716265,
    x2: 12.611693,
    y2: 12.6082873,
    id: "Line-4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.172762918,
    y1: 0.172716265,
    x2: 12.611693,
    y2: 12.6082873,
    id: "Line-4-Copy",
    transform: "translate(6.3922, 6.3905) scale(1, -1) translate(-6.3922, -6.3905)"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemoClose);
export default __webpack_public_path__ + "static/media/demoClose.e0bc240ccc1ade0329b04e7358b63f8a.svg";
export { ForwardRef as ReactComponent };